import FaceAdd20 from '@carbon/icons-react/es/face--add/20';
import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import React, { FC } from 'react';
import styled from 'styled-components';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { EmojiPicker as EmojiPickerComp } from 'components/atoms/rich-text-editor/emoji-picker';
import { executeAddEmojiCommand } from 'components/atoms/rich-text-editor/execute-emoji-command';
import { ToolButtonWrapper } from '../tool-button-wrapper';

interface Props {
  editor: Editor;
}

const ToolBtnWrapper = styled(ToolButtonWrapper)`
  padding: 4px;
`;

export const EmojiPicker: FC<Props> = ({ editor }: Props) => (
  <ToolBtnWrapper>
    <EmojiPickerComp
      icon={
        <IconWrapper>
          <FaceAdd20 />
        </IconWrapper>
      }
      enabled
      onSelect={(emoji) => executeAddEmojiCommand(emoji, editor)}
      hideHoverEffect
    />
  </ToolBtnWrapper>
);
